const coordinatesDistance = (coordinates1, coordinates2) => {
  if (coordinates2) {
    const earthRadiusInKM = 6371.0710;
    const latitudeRadians1 = getLatitudeDegreesInRadians(coordinates1.latitude);
    const latitudeRadians2 = getLatitudeDegreesInRadians(coordinates2.latitude);

    const latitudeRadianDifference = latitudeRadians2 - latitudeRadians1;
    const longitudeRadianDifference =
      getLongitudeRadianDifference(
        coordinates2.longitude,
        coordinates1.longitude,
      );

    const distance =
      haversineDistanceByRadianDifferences(
        earthRadiusInKM,
        latitudeRadianDifference,
        longitudeRadianDifference,
        latitudeRadians1,
        latitudeRadians2,
      );

    return distance;
  } else return null;
};

function getLatitudeDegreesInRadians(coordinateLatitude) {
  return coordinateLatitude * (Math.PI / 180);
}

function getLongitudeRadianDifference(
  coordinates1Longitude,
  coordinates2Longitude,
) {
  return (coordinates1Longitude - coordinates2Longitude) * (Math.PI / 180);
}

function haversineDistanceByRadianDifferences(
  sphereRadius,
  latitudeRadianDifference,
  longitudeRadianDifference,
  latitudeRadians1,
  latitudeRadians2,
) {
  const distance =
    2 * sphereRadius *
    Math.asin(
      Math.sqrt(
        Math.sin(latitudeRadianDifference / 2) *
        Math.sin(latitudeRadianDifference / 2) + Math.cos(latitudeRadians1) *
        Math.cos(latitudeRadians2) *
        Math.sin(longitudeRadianDifference / 2) *
        Math.sin(longitudeRadianDifference / 2)
      )
    );

  return distance;
}

export default coordinatesDistance;
